import React from 'react'
import StatusBadge from "../../../../components/StatusBadge/StatusBadge"
import { fundsHoldLabel } from "../../../../utils/fundsAvailability"

const StatusCell = ({ props, userRole }) => {
  const status = props.row.status?.label
  const label = props.formattedValue?.label
  const displayLabel = status === 'Failed' ? (props?.row.transactionData?.reasonCode === "202" ? 'NSF' : 'Error') : label

  // An ACH/e-check that has settled but not passed its funds-availability date reads
  // "In Transit · {date}" rather than "Cleared". A settled e-check can still be returned for
  // uncollected funds, so calling it Cleared claims money that is not in the account yet.
  //
  // This used to be affiliates only, to stop a payout being released against returnable money.
  // Mendy, 4 Sep 2026: "you are placing fake clears into the system." Internal staff and
  // affiliates were reading different words for the same payment, and the internal one was the
  // one that was wrong. Everyone sees the same thing now.
  //
  // `availableOn` is absent on cards and on legacy rows, so both fall straight through — cards
  // clear live, which is what was asked for. A FAILURE is never held behind this: the derived
  // state only fires on 'cleared', so a bounce still shows the moment it lands.
  const hold = fundsHoldLabel({
    statusValue: props.row.status?.value,
    availableOn: props.row.transactionData?.availableOn,
  })
  if (hold) {
    return <StatusBadge label={hold.label} bgColor={hold.bgColor} textColor={hold.textColor} width="w-[140px]" />
  }

  return (
    <StatusBadge
      label={displayLabel}
      bgColor={props?.row.status?.bgColor}
      textColor={props?.row.status?.textColor}
    />
  )
}

export default StatusCell
